import { allTrackers } from "app/services/track/track";

import { createScoreCriteriaTrackingService } from "./factory";

const scoreCriteriaTrackingService = createScoreCriteriaTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default scoreCriteriaTrackingService;
